<template>
  <quotes :client-id="clientId" :hideTitle="true" />
</template>

<script>
import { mapActions } from "vuex";
import Quotes from "src/views/Pages/Quotes";
export default {
  props: {
    clientId: Number,
  },

  components: {
    Quotes,
  },

  methods: {
    ...mapActions({
      getAll: "quote/getAll",
    }),

    async refresh() {
      await this.getAll();
    },
  },

};
</script>